module.exports = __webpack_public_path__ + "static/media/yandexLogo_Light.259d4ee8.svg";